import * as colors from 'foundation/colors';
import { VetCategories } from 'types/enums';

export const SCROLLBAR_SIZE = 6;

export const scrollBarStyle = {
    '&::-webkit-scrollbar': {
        backgroundColor: 'none',
        width: SCROLLBAR_SIZE,
        height: SCROLLBAR_SIZE,
    },

    '&::-webkit-scrollbar-track': {
        backgroundColor: 'transparent',
    },

    '&::-webkit-scrollbar-thumb': {
        backgroundColor: colors.black.disabled,
        borderRadius: 10,
    },
    'scrollbar-width': SCROLLBAR_SIZE,
    'scrollbar-height': SCROLLBAR_SIZE,
    'scrollbar-color': `${colors.black.disabled} ${colors.neutral._200}`,
};

export const elementHasHorizontalScroll = (el: Element) => {
    return el.scrollWidth > el.clientWidth;
};

export const elementHasVerticalScroll = (el: Element) => {
    return el.scrollHeight > el.clientHeight;
};

/**
 * Returns the number of pixels which the given elements is outside the sides of the screen.
 * Optionally, you can take a margin from the screen edge into consideration.
 *
 * Returns 0 if the element does not overflow.
 *
 * @param element
 * @param marginFromScreenEdge
 */
export const distanceOutsideOfScreen = (
    element: HTMLElement,
    margins?: { top?: number; right?: number; bottom?: number; left?: number },
) => {
    const allMargins = {
        top: margins?.top || 0,
        right: margins?.right || 0,
        bottom: margins?.bottom || 0,
        left: margins?.left || 0,
    };
    const bounds = element.getBoundingClientRect();
    const overflowRight = bounds.right - window.innerWidth + allMargins.right;
    const overflowLeft = allMargins.left - bounds.left;
    const overflowTop = allMargins.top - bounds.top;
    const overflowBottom = bounds.bottom - window.innerHeight + allMargins.bottom;
    return {
        top: Math.max(overflowTop, 0),
        right: Math.max(overflowRight, 0),
        bottom: Math.max(overflowBottom, 0),
        left: Math.max(overflowLeft, 0),
    };
};

export const VetCategoryColors = {
    [VetCategories.VETERINARIAN]: {
        primary: colors.calendar.blue,
        secondary: colors.calendar.blueLight,
    },
    [VetCategories.PET_NURSE]: {
        primary: colors.calendar.purple,
        secondary: colors.calendar.purpleLight,
    },
    [VetCategories.PRESCRIPTION]: {
        primary: colors.calendar.pink,
        secondary: colors.calendar.pinkLight,
    },
    [VetCategories.BEHAVIOR]: {
        primary: colors.calendar.yellow,
        secondary: colors.calendar.yellowLight,
    },
    [VetCategories.HEALTH_CHECK]: {
        primary: colors.calendar.green,
        secondary: colors.calendar.greenLight,
    },
    [VetCategories.FEEDING]: {
        primary: colors.calendar.brown,
        secondary: colors.calendar.brownLight,
    },
    [VetCategories.BREEDER]: {
        primary: colors.calendar.brown,
        secondary: colors.calendar.brownLight,
    },
    default: {
        primary: colors.calendar.blue,
        secondary: colors.calendar.blueLight,
    },
};
